// Apolo IDE — sessionStatusMeta (sprint code-session-board, E2-WS1).
//
// PURO (sem React): mapeia DerivedStatus → metadado de UI. `tone` é uma chave
// semântica (o componente resolve pros tokens --apolo-*), `icon` é o NOME de um
// ícone lucide (o componente resolve). Status nunca é comunicado só por cor:
// `label` (texto) sempre acompanha. attention = precisa de ação do Pedro.

export const DERIVED_STATUSES = ['running', 'blocked', 'review', 'needs_you', 'idle'];

const META = {
  running:   { label: 'Rodando',        tone: 'success', icon: 'Loader2',        attention: false },
  blocked:   { label: 'Travado',        tone: 'danger',  icon: 'AlertTriangle',  attention: true },
  review:    { label: 'Review',         tone: 'info',    icon: 'GitPullRequest', attention: true },
  needs_you: { label: 'Sua vez',        tone: 'warn',    icon: 'CircleDot',      attention: true },
  idle:      { label: 'Parada',         tone: 'neutral', icon: 'Circle',         attention: false },
};

const FALLBACK = { label: 'Desconhecido', tone: 'neutral', icon: 'Circle', attention: false };

export const ATTENTION_STATUSES = DERIVED_STATUSES.filter((s) => META[s].attention);

export function sessionStatusMeta(status) {
  return META[status] || FALLBACK;
}
